import styled from 'styled-components';

export const SecurityTabStyle = styled.div`
  position: relative;
  font-size: 16px;
  line-height: 20px;
  color: var(--light-gray);

  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    margin: 0 0 10px;
    color: var(--text-color);
  }

  .text {
    display: block;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: var(--light-gray);
  }

  .info-list {
    width: 100%;

    .btn {
      width: 100%;
      margin: 0 0 25px 0;
      padding: 0 20px 0 0;
      position: relative;
      text-align: left;

      &:hover {
        opacity: 0.8;
      }
    }

    .icon {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      font-size: 24px;
      line-height: 1;
    }
  }
`;
